import { render, staticRenderFns } from "./CampaignNotifications.vue?vue&type=template&id=6c7870a5&scoped=true"
import script from "./CampaignNotifications.vue?vue&type=script&lang=js"
export * from "./CampaignNotifications.vue?vue&type=script&lang=js"
import style0 from "./CampaignNotifications.vue?vue&type=style&index=0&id=6c7870a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7870a5",
  null
  
)

export default component.exports